export const COMPLETE_PROFILE_FROM = {
  DRAFT: "draft",
  ROOM_DETAIL: "detail",
  DEFAULT: "default",
  EDIT: "edit",
};
